import { ApiClientInstance, ServiceHelper } from "utils/helpers";
import { AuthEnums } from "models/enums";
import { ServiceConstants } from "utils/constants";

/**
 * @deprecated This service is deprecated. Use useReceiptPaymentMethodService hook instead.
 *
 * @see useReceiptPaymentMethodService - The replacement hook
 * @see https://app.clickup.com/4523827/v/dc/4a1tk-21632/4a1tk-8592
 */
const ReceiptPaymentMethodService = {
  getAll: () => {
    return ServiceHelper.getAllPages((page) =>
      ApiClientInstance(AuthEnums.AuthType.Company).ReceiptPaymentMethodClient.GetByFilter({
        ...ServiceConstants.DefaultFilter,
        orderByProperty: "Name",
        page: page,
        includeAllEmployees: false,
        includeCompanyIdForWintCards: true,
      })
    );
  },
};

export default ReceiptPaymentMethodService;
